// extracted by mini-css-extract-plugin
export var actionButton = "_7a-1";
export var actionButtons = "_7a-2";
export var actions = "_7a-0";
export var aiUnread = "_7a-10";
export var alignCenter = "_7a-h";
export var backWrapper = "_7a-3";
export var cellContainer = "_7a-4";
export var checkboxContainer = "_7a-5";
export var contentContainer = "_7a-6";
export var contentHeader = "_7a-8";
export var conversationsTableWrapper = "_7a-s";
export var draftReplyBadgeContainer = "_7a-m";
export var dropdownItem = "_7a-b";
export var dropdownItemsContainer = "_7a-a";
export var dropdownTitle = "_7a-c";
export var errorIcon = "_7a-7";
export var filter = "_7a-d";
export var gray = "_7a-i";
export var headerActionButtons = "_7a-e";
export var headerCheckboxContainer = "_7a-f";
export var icon = "_7a-j";
export var menuContainer = "_7a-k";
export var noMoreTicketsIcon = "_7a-12";
export var noMoreTicketsSubText = "_7a-13";
export var oneLine = "_7a-l";
export var optionsButton = "_7a-n";
export var plus = "_7a-o";
export var portalButtonsWrapper = "_7a-g";
export var red = "_7a-p";
export var scrolledTop = "_7a-9";
export var search = "_7a-q";
export var selectedConversationsCount = "_7a-r";
export var spinner = "_7a-t";
export var strong = "_7a-u";
export var summaryCell = "_7a-v";
export var tableContainer = "_7a-11";
export var tagContainer = "_7a-w";
export var threeDots = "_7a-x";
export var twoLines = "_7a-y";
export var unread = "_7a-z";